import { HoffmanGlobals } from '../window';

export const getWindow = () => window;

export const getHoffmanEnvironment = (): HoffmanGlobals => window.HOFFMANN;
